<ngx-spinner [name]="'relatorio-comissao'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório de comissão por vendedor</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field appearance="fill">
                    <mat-label>Mês</mat-label>
                    <mat-select [(ngModel)]="sMesBusca">
                        <mat-option *ngFor="let tipo of aMesBusca" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Ano</mat-label>
                    <mat-select [(ngModel)]="sAnoBusca">
                        <mat-option *ngFor="let tipo of aAnosBusca" [value]="tipo.name">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-3">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Vendedor</mat-label>
                    <mat-select [(ngModel)]="sBuscaVendedor" required [disabled]="tipoCadastro === 'Vendedor' ? true : false">
                        <mat-option *ngFor="let vendedor of aVendedores" [value]="vendedor.value">
                            {{vendedor.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-auto">
                <button class="mt-4" mat-flat-button color="primary" (click)="buscarVendasPeriodo()">
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>
        </div>

        <div class="row mt-4" *ngIf="bConsulta">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <div class="row mt-2">
                    <div class="col-sm text-right">
                        <button mat-flat-button color="warn" (click)="exportar()">
                            <mat-icon>print</mat-icon> Exportar
                        </button>
                    </div>
                </div>

                <div class="row mt-4">
                    <!-- <div class="col-sm"> -->
                    <div class="col-auto">
                        <div class="borda">
                            <div style="margin: 16px;">
                                <div class="titulo">Por status do pedido</div>
                                <div>
                                    <div class="preContador">Total de pedidos ENTREGUES no período:</div>
                                    {{contEntregues}}
                                </div>
                                <div>
                                    <div class="preContador">Cancelados:</div> {{contCancelados}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-auto">
                        <div class="borda">

                            <div style="margin: 16px;">
                                <div class="titulo">Por status do pagamento</div>
                                <div>
                                    <div class="preContador">Pendente:</div> {{contPagamentoPendente}}
                                </div>
                                <div>
                                    <div class="preContador">Confirmado:</div> {{contPagamentoConfirmado}}
                                </div>
                                <div>
                                    <div class="preContador">Cancelado:</div> {{contPagamentoCancelado}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-auto">
                        <div class="borda">

                            <div style="margin: 16px;">
                                <div class="titulo">Por forma de pagamento</div>
                                <div>
                                    <div class="preContador">Boleto:</div> {{contPagamentoBoleto}}
                                </div>
                                <div>
                                    <div class="preContador">Crédito:</div> {{contPagamentoCredito}}
                                </div>
                                <div>
                                    <div class="preContador">Débito:</div> {{contPagamentoDebito}}
                                </div>
                                <div>
                                    <div class="preContador">Dinheiro:</div> {{contPagamentDinheiro}}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-auto">
                        <div class="borda">
                            <div style="margin: 16px;">
                                <div class="preContador">Total em vendas</div>
                                <div style="font-weight: bold;"> R$
                                    {{somaTotal.toFixed(2).replace('.',',')}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-auto">
                        <div class="borda">
                            <div style="margin: 16px;">
                                <div class="preContador">Comissão ({{comissaoUtilizada}}%)</div>
                                <div style="font-weight: bold;"> R$
                                    {{totalComissao.toFixed(2).replace('.',',')}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-sm">
                        <div style="color: gray; font-size: small;">* Pedidos cancelado aparecem na exportação mas não são contabilizados na comissão</div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>